// Reads theme colors from CSS custom properties so canvases match the page.
import type { SegmentKind } from '../parsers/types';

export interface Theme {
  bg: string; panel: string; panel2: string; line: string; line2: string; text: string; text2: string; muted: string;
  accent: string; sel: string; playhead: string; wave: string; waveDim: string; warn: string;
  kind: Record<SegmentKind, string>;
  dark: boolean;
}

let cached: Theme | null = null;
const listeners = new Set<() => void>();

export function theme(): Theme {
  if (cached) return cached;
  const cs = getComputedStyle(document.documentElement);
  const v = (n: string) => cs.getPropertyValue(n).trim();
  cached = {
    bg: v('--bg'), panel: v('--panel'), panel2: v('--panel2'), line: v('--line'), line2: v('--line2'), text: v('--text'),
    text2: v('--text2'), muted: v('--muted'), accent: v('--accent'), sel: v('--sel'), playhead: v('--playhead'),
    wave: v('--wave'), waveDim: v('--wave-dim'), warn: v('--warn'),
    kind: {
      audio: v('--k-audio'), header: v('--k-header'), metadata: v('--k-metadata'), image: v('--k-image'),
      index: v('--k-index'), padding: v('--k-padding'), container: v('--k-container'), unknown: v('--k-unknown'),
    },
    dark: matchMedia('(prefers-color-scheme: dark)').matches,
  };
  return cached;
}
export function onTheme(f: () => void) {
  listeners.add(f);
}
matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
  cached = null;
  listeners.forEach((f) => f());
});

/** Hex color + alpha → rgba() string. */
export function alpha(hex: string, a: number): string {
  const m = hex.replace('#', '');
  const n = parseInt(m.length === 3 ? m.split('').map((c) => c + c).join('') : m, 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`;
}

/** A distinct color for field i (for hex / bit highlighting). */
export function fieldColor(i: number): string {
  const palette = ['#f5b841', '#38bdf8', '#a78bfa', '#f472b6', '#4ade80', '#fb923c', '#22d3ee', '#e879f9', '#facc15', '#60a5fa', '#f87171', '#34d399'];
  return palette[i % palette.length];
}
